var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-page"},[_c('section',{staticClass:"image-section"}),_c('section',{staticClass:"main"},[_c('div',[_c('eg-logo')],1),_c('form',{staticClass:"form-content"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }